var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hide-overflow",attrs:{"id":"facelift"}},[_c('v-container',{attrs:{"mt-3":""}},[_c('v-layout',[_c('v-flex',[_c('h1',[_vm._v("Simoni Facelift")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }